import { render } from "./AddRecipePage.vue?vue&type=template&id=2da90d98&scoped=true"
import script from "./AddRecipePage.vue?vue&type=script&lang=js"
export * from "./AddRecipePage.vue?vue&type=script&lang=js"

import "./AddRecipePage.vue?vue&type=style&index=0&id=2da90d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da90d98"]])

export default __exports__